var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrations04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d7bbff;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #efe6ff;\n      }\n\n      .st3 {\n        fill: #2e1754;\n      }\n\n      .st4 {\n        fill: #4d2384;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 149.97,
    y: 189.52,
    width: 192.47,
    height: 122.96,
    rx: 7.63,
    ry: 7.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.44,298.01v-102.89c0-3.09-2.5-5.59-5.59-5.59h-150.72c.02,1.38,0,2.73.18,3.75,1.28,7.03,4.66,13.65,9.33,19.04,6.78,7.82,16.08,13.15,25.89,16.43,5.08,1.7,10.36,2.89,15.16,5.24,4.81,2.36,9.23,6.13,10.86,11.23,1.43,4.48.55,9.41,1.67,13.98,1.63,6.65,7.37,11.7,13.76,14.16,6.39,2.46,13.39,2.7,20.24,2.62,6.3-.07,12.87-.35,18.57,2.31,7.01,3.27,11.48,10.4,18.11,14.38,5.77,3.46,12.69,4.28,19.37,5.01,1.04.12,2.09.23,3.14.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 295.03,
    y: 187.03,
    width: 21.7,
    height: 126.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 235.68,
    y: 152.02,
    width: 20.91,
    height: 197.96,
    transform: "translate(497.14 4.86) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 163.74,
    y: 202.51,
    width: 41.25,
    height: 21.7,
    rx: 10.85,
    ry: 10.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 163.68,
    y: 297.16,
    width: 48.22,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 163.63,
    y: 302.27,
    width: 83.62,
    height: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M299.64,252.3s23.87,16.62,40.24,19.78c6.6,1.27,12.68-3.95,12.68-10.66v-28.69c0-8.02-8.44-13.32-15.61-9.72-16.14,8.12-37.31,29.29-37.31,29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.11,252.3s-23.87,16.62-40.24,19.78c-6.6,1.27-12.68-3.95-12.68-10.66v-28.69c0-8.02,8.44-13.32,15.61-9.72,16.14,8.12,37.31,29.29,37.31,29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319.28,238.43s20.55-19.54,27.02-12.95c6.47,6.58-27.02,12.95-27.02,12.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.05,238.43s-20.55-19.54-27.02-12.95c-6.47,6.58,27.02,12.95,27.02,12.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.89,272.57c-2.49,0-4.93-.87-6.91-2.5-2.59-2.14-4.08-5.29-4.08-8.64v-28.69c0-3.9,1.99-7.45,5.31-9.5,3.28-2.02,7.29-2.2,10.72-.48,4.78,2.4,10.47,6.19,16.9,11.24l6.99,5.62-.37.45-6.99-5.61c-6.4-5.03-12.06-8.79-16.8-11.18-3.25-1.63-7.04-1.46-10.15.45-3.15,1.94-5.03,5.31-5.03,9v28.69c0,3.18,1.41,6.17,3.86,8.19,2.38,1.97,5.47,2.76,8.46,2.18,12.76-2.46,30.16-13.18,37.05-17.68l.32.49c-6.92,4.51-24.4,15.28-37.26,17.76-.68.13-1.36.2-2.04.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,272.57c-.68,0-1.36-.06-2.04-.2-12.86-2.48-30.34-13.25-37.26-17.76l.32-.49c6.89,4.49,24.29,15.21,37.05,17.68,3,.58,6.08-.22,8.46-2.18,2.46-2.03,3.86-5.01,3.86-8.19v-28.69c0-3.7-1.88-7.06-5.03-9-3.11-1.92-6.9-2.09-10.15-.45-4.74,2.39-10.4,6.15-16.8,11.18l-6.98,5.61-.37-.45,6.99-5.61c6.44-5.06,12.13-8.84,16.91-11.24,3.43-1.72,7.43-1.55,10.72.48,3.33,2.05,5.31,5.6,5.31,9.5v28.69c0,3.35-1.49,6.5-4.08,8.64-1.98,1.63-4.42,2.5-6.91,2.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 297.65,
    y: 238.43,
    width: 17.54,
    height: 25.81,
    rx: 8.77,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.96,
    y: 240.26,
    width: 66.23,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.15,
    y: 261.14,
    width: 112.04,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.11,
    y: 245.99,
    width: 6.87,
    height: 0.58,
    transform: "translate(-95.39 119.93) rotate(-28.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.7,
    y: 249.06,
    width: 6.87,
    height: 0.58,
    transform: "translate(-96.91 120.1) rotate(-28.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.25,264.53h-13.66c-1.23,0-2.23-1-2.23-2.23v-21.93c0-1.23,1-2.23,2.23-2.23h13.66c1.23,0,2.23,1,2.23,2.23v21.93c0,1.23-1,2.23-2.23,2.23ZM299.59,238.72c-.91,0-1.65.74-1.65,1.65v21.93c0,.91.74,1.65,1.65,1.65h13.66c.91,0,1.65-.74,1.65-1.65v-21.93c0-.91-.74-1.65-1.65-1.65h-13.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,238.71c-20.5-3.97-25.84-8.31-26.06-8.5l.38-.45c.05.04,5.49,4.44,25.79,8.37l-.11.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,229.73l-.35-.46c.36-.27,8.84-6.7,14.19-5.24l-.15.56c-5.07-1.39-13.59,5.07-13.68,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,251.29c-.21,0-.27-.16-.29-.29h0,0s0-.09,0-.12l-.33-11.4.58-.02c.11,3.91.33,11.36.33,11.52h-.29s0,.02,0,.02h.29l-.29.29s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.88,
    y: 248.31,
    width: 0.58,
    height: 6.5,
    transform: "translate(-12.49 18.31) rotate(-2.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.85,
    y: 254.81,
    width: 0.58,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.32,
    y: 251.56,
    width: 0.58,
    height: 5.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.77,
    y: 242.77,
    width: 0.58,
    height: 4.76,
    transform: "translate(-86.48 225.83) rotate(-36.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.6,
    y: 246.79,
    width: 0.58,
    height: 2.8,
    transform: "translate(-88.44 228.76) rotate(-36.57)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.02 236.93 316.43 236.93 316.43 187.32 308.42 187.32 308.42 186.74 317.02 186.74 317.02 236.93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.73,
    y: 208.13,
    width: 0.58,
    height: 28.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.8,
    y: 262.7,
    width: 0.58,
    height: 42.01
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.08 313.03 310.09 313.03 310.09 312.45 316.5 312.45 316.56 262.8 317.15 262.8 317.08 313.03"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.35,
    y: 275.68,
    width: 3.6,
    height: 0.58,
    transform: "translate(-105.18 298.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.34,
    y: 278.23,
    width: 3.61,
    height: 0.58,
    transform: "translate(-106.93 299.91) rotate(-45.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.73,221.86h-.58v-27.05c0-2.75-2.24-5-5-5h-11.06v-.58h11.06c3.08,0,5.58,2.5,5.58,5.58v27.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.05,312.77h-42.59c-3.19,0-5.79-2.6-5.79-5.79v-36.7h.58v36.7c0,2.87,2.33,5.2,5.2,5.2h42.59v.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 194.45,
    width: 16.61,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.13,
    y: 198.73,
    width: 12.96,
    height: 0.58
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.49,
    y: 311.91,
    width: 427.03,
    height: 1.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrations04);
export default __webpack_public_path__ + "static/media/illustrations-04.966ba26f2fcc6b081f16dfc51947ae07.svg";
export { ForwardRef as ReactComponent };